import React, { useState, useEffect, useRef } from 'react';
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Form,
  FormGroup,
  Label,
} from 'reactstrap';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { deleteSelectedAddress, newAddress, editAddress } from '../actions/formActions';
import classnames from 'classnames';

const Addresses = (props: any) => {
  const { auth, errors: propsErrors } = props;

  const [modal, setModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const [showNewAddressForm, setShowNewAddressForm] = useState(false);
  const [address, setAddress] = useState('');
  const [suburb, setSuburb] = useState('');
  const [postcode, setPostcode] = useState('');
  const [editAddressId, setEditAddressId] = useState('');
  const [editAddressVal, setEditAddressVal] = useState('');
  const [editSuburb, setEditSuburb] = useState('');
  const [editPostcode, setEditPostcode] = useState('');
  const [editShowSetAsDefault, setEditShowSetAsDefault] = useState(false);
  const [setAsDefault, setSetAsDefault] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [showEditForm, setShowEditForm] = useState(false);
  const [editSetAsDefault, setEditSetAsDefault] = useState(false);

  const prevAdressRef = useRef(auth.user.adress);
  const prevErrorsRef = useRef(propsErrors);

  useEffect(() => {
    if (auth.user.adress !== prevAdressRef.current) {
      prevAdressRef.current = auth.user.adress;
      setShowNewAddressForm(false);
      setAddress('');
      setSuburb('');
      setPostcode('');
      setErrors({});
      setEditAddressId('');
      setEditAddressVal('');
      setEditSuburb('');
      setEditPostcode('');
      setEditShowSetAsDefault(false);
      setShowEditForm(false);
      setEditSetAsDefault(false);
    }
    if (propsErrors !== prevErrorsRef.current) {
      prevErrorsRef.current = propsErrors;
      setErrors(propsErrors);
    }
  }, [auth.user.adress, propsErrors]);

  const handleEditForm = (addr) => {
    if (showEditForm) {
      if (addr.streetAdress !== editAddressVal) {
        if (addr.addressType === 'default') {
          setShowEditForm(true);
          setEditAddressId(addr._id);
          setEditAddressVal(addr.streetAdress);
          setEditSuburb(addr.suburb);
          setEditPostcode(addr.zipCode);
          setEditShowSetAsDefault(false);
        } else {
          setShowEditForm(true);
          setEditAddressId(addr._id);
          setEditAddressVal(addr.streetAdress);
          setEditSuburb(addr.suburb);
          setEditPostcode(addr.zipCode);
          setEditShowSetAsDefault(true);
        }
      } else {
        setShowEditForm(false);
        setEditAddressVal('');
        setEditSuburb('');
        setEditPostcode('');
        setEditAddressId('');
        setEditShowSetAsDefault(false);
      }
    } else {
      if (addr.addressType === 'default') {
        setShowEditForm(true);
        setEditAddressId(addr._id);
        setEditAddressVal(addr.streetAdress);
        setEditSuburb(addr.suburb);
        setEditPostcode(addr.zipCode);
      } else {
        setShowEditForm(true);
        setEditAddressId(addr._id);
        setEditAddressVal(addr.streetAdress);
        setEditSuburb(addr.suburb);
        setEditPostcode(addr.zipCode);
        setEditShowSetAsDefault(true);
      }
    }
  };

  const handleCheckBox = () => {
    setSetAsDefault((prev) => !prev);
  };

  const editHandleCheckBox = () => {
    setEditSetAsDefault((prev) => !prev);
  };

  const setSelectedAddress = (addr) => {
    setSelected(addr);
    setModal(true);
  };

  const toggle = () => {
    setModal((prev) => !prev);
  };

  const deleteAddress = () => {
    setModal(false);
    let data: any = {};
    data.user = auth.user;
    data.address = selected;
    props.deleteSelectedAddress(data);
    setSelected(null);
  };

  const handleNewAddress = () => {
    setShowNewAddressForm((prev) => !prev);
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case 'address':
        setAddress(value);
        break;
      case 'suburb':
        setSuburb(value);
        break;
      case 'postcode':
        setPostcode(value);
        break;
      case 'editAddress':
        setEditAddressVal(value);
        break;
      case 'editSuburb':
        setEditSuburb(value);
        break;
      case 'editPostcode':
        setEditPostcode(value);
        break;
      default:
        break;
    }
  };

  const addNewAddress = () => {
    let data: any = {};
    data.user = auth.user;
    data.streetAdress = address;
    data.suburb = suburb;
    data.zipCode = postcode;
    data.addNewAddress = true;
    if (setAsDefault) {
      data.setAsDefault = true;
    }
    props.newAddress(data);
  };

  const editUserAddress = () => {
    let data: any = {};
    data.user = auth.user;
    data.editAddressId = editAddressId;
    data.editStreetAdress = editAddressVal;
    data.editSuburb = editSuburb;
    data.editPostcode = editPostcode;
    data.editSetAsDefault = editSetAsDefault;
    data.editAddress = true;
    props.editAddress(data);
    setShowEditForm(false);
  };

  return (
    <div className="dashboard-view">
      <div>
        <Helmet>
          <title>Addresses - Frozberries Victoria</title>
          <meta name="description" content="Account - Frozberries Victoria" />
        </Helmet>
      </div>
      <Row className="mx-5 my-3 border-bottom py-3">
        <Col>
          <h4 style={{ fontWeight: 'bolder' }}>My Account</h4>
        </Col>
      </Row>
      <Row className="mx-5 my-3  py-3">
        <Col>
          <Button onClick={handleNewAddress} color="success" className="btn font-weight-bold">
            Add New Address
          </Button>
        </Col>
      </Row>
      {showNewAddressForm && (
        <Row className="mx-5">
          <Col>
            <Form className="pt-3">
              <FormGroup>
                <Input
                  className={classnames('', { 'is-invalid': errors.address })}
                  placeholder="Address*"
                  type="text"
                  onChange={onChange}
                  value={address}
                  name="address"
                />
                <div className="invalid-feedback">{errors.address}</div>
              </FormGroup>

              <FormGroup>
                <Input
                  className={classnames('', { 'is-invalid': errors.suburb })}
                  placeholder="Suburb*"
                  type="text"
                  onChange={onChange}
                  value={suburb}
                  name="suburb"
                />
                <div className="invalid-feedback">{errors.suburb}</div>
              </FormGroup>

              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Input
                      placeholder="State*"
                      type="text"
                      onChange={onChange}
                      value="Victoria"
                      disabled={true}
                      name="region"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Input
                      className={classnames('', { 'is-invalid': errors.postcode })}
                      placeholder="Postal Code*"
                      type="text"
                      onChange={onChange}
                      value={postcode}
                      name="postcode"
                    />
                    <div className="invalid-feedback">{errors.postcode}</div>
                  </FormGroup>
                </Col>
              </Row>
              {auth.user.adress.length !== 0 && (
                <FormGroup className="ml-4">
                  <Label check>
                    <Input type="checkbox" id="handleCheckBox" onClick={handleCheckBox} />
                    Set as Default
                  </Label>
                </FormGroup>
              )}
            </Form>
            <Button
              onClick={addNewAddress}
              disabled={address === '' || suburb === '' || postcode === ''}
              outline
              color="dark"
            >
              ADD NEW ADDRESS
            </Button>
          </Col>
        </Row>
      )}
      <Row className="mx-5 my-3  py-3">
        <Col>
          <h5 className="border-bottom" style={{ fontWeight: 'bold' }}>
            Customer Address Book
          </h5>

          <div>
            <p>
              {auth.user.firstName} {auth.user.lastName}
            </p>

            <Row>
              {auth.user.adress.length !== 0 &&
                auth.user.adress
                  .sort(function (left, right) {
                    return left.hasOwnProperty('addressType')
                      ? -1
                      : right.hasOwnProperty('addressType')
                        ? 1
                        : 0;
                  })
                  .map((eachAdress) => (
                    <Col className=" my-3" key={eachAdress._id} md="3" sm="4" xs="6">
                      <p style={{ minHeight: '80px' }}>
                        <span>
                          {eachAdress.streetAdress} {eachAdress.addressType && `(default)`}
                        </span>{' '}
                        <br />
                        <span>
                          {eachAdress.suburb} Victoria {eachAdress.zipCode}
                        </span>
                      </p>
                      <Button
                        onClick={() => handleEditForm(eachAdress)}
                        color="dark"
                        outline
                        className="btn btn-sm font-weight-bold d-inline mr-2"
                      >
                        Edit
                      </Button>
                      <Button
                        onClick={() => setSelectedAddress(eachAdress)}
                        color="danger"
                        outline
                        className="btn btn-sm font-weight-bold d-inline"
                      >
                        Delete
                      </Button>
                    </Col>
                  ))}
            </Row>

            {showEditForm && (
              <Row>
                <Col>
                  <Form className="pt-3">
                    <FormGroup>
                      <Input
                        className={classnames('', { 'is-invalid': errors.editAddress })}
                        placeholder="Address*"
                        type="text"
                        onChange={onChange}
                        value={editAddressVal}
                        name="editAddress"
                      />
                      <div className="invalid-feedback">{errors.editAddress}</div>
                    </FormGroup>

                    <FormGroup>
                      <Input
                        className={classnames('', { 'is-invalid': errors.editSuburb })}
                        placeholder="Suburb*"
                        type="text"
                        onChange={onChange}
                        value={editSuburb}
                        name="editSuburb"
                      />
                      <div className="invalid-feedback">{errors.editSuburb}</div>
                    </FormGroup>

                    <Row form>
                      <Col md={6}>
                        <FormGroup>
                          <Input
                            placeholder="State*"
                            type="text"
                            onChange={onChange}
                            value="Victoria"
                            disabled={true}
                            name="region"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Input
                            className={classnames('', { 'is-invalid': errors.editPostcode })}
                            placeholder="Postal Code*"
                            type="text"
                            onChange={onChange}
                            value={editPostcode}
                            name="editPostcode"
                          />
                          <div className="invalid-feedback">{errors.editPostcode}</div>
                        </FormGroup>
                      </Col>
                    </Row>
                    {editShowSetAsDefault && (
                      <FormGroup className="ml-4">
                        <Label check>
                          <Input
                            type="checkbox"
                            id="editHandleCheckBox"
                            onClick={editHandleCheckBox}
                          />
                          Set as Default
                        </Label>
                      </FormGroup>
                    )}
                  </Form>
                  <Button
                    onClick={editUserAddress}
                    disabled={editAddressVal === '' || editSuburb === '' || editSuburb === ''}
                    outline
                    color="dark"
                  >
                    UPDATE
                  </Button>
                </Col>
              </Row>
            )}

            {auth.user.adress.length === 0 && (
              <div>
                <p className="font-weight-bold">You don't have any saved addresses.</p>
              </div>
            )}

            <Modal isOpen={modal} toggle={toggle}>
              <ModalHeader toggle={toggle}>
                Are you sure you wish to delete the following address?
              </ModalHeader>
              <ModalBody className="font-weight-bold">
                {selected !== null && (
                  <p>
                    <span> {selected.streetAdress} </span> <br />
                    <span>
                      {selected.suburb} Victoria {selected.zipCode}
                    </span>
                  </p>
                )}
              </ModalBody>
              <ModalFooter>
                <Button color="danger" onClick={deleteAddress}>
                  Delete
                </Button>{' '}
                <Button color="secondary" onClick={toggle}>
                  Cancel
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  errors: state.errors,
  auth: state.form,
  cart: state.cart,
});

export default connect(mapStateToProps, { deleteSelectedAddress, newAddress, editAddress })(
  Addresses
);
